import { Preferences } from '@capacitor/preferences';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileStorageService {
  async set(key: string, value: any) {
    await Preferences.set({ key, value: JSON.stringify(value) });
  }

  async get(key: string) {
    const result = await Preferences.get({ key });
    return result.value ? JSON.parse(result.value) : null;
  }

  async remove(key: string) {
    await Preferences.remove({ key });
  }
}
